import { CardContainer } from "@/components/card-container";
import { Skeleton } from "@/components/ui/skeleton";

export const TaxFormsSkeleton = () => {
  return (
    <div
      role="status"
      aria-label="Loading tax forms"
      className="flex flex-col gap-4"
    >
      <div className="flex sm:justify-end">
        <Skeleton className="w-40 h-10 mb-4" />
      </div>

      <CardContainer>
        <CardContainer.Header>
          <CardContainer.HeaderContent>
            <CardContainer.CardTitle>
              <Skeleton className="w-32 h-4" />
            </CardContainer.CardTitle>
            <CardContainer.CardDescription>
              <Skeleton className="w-44 h-4" />
            </CardContainer.CardDescription>
          </CardContainer.HeaderContent>
          <CardContainer.TopRightContent>
            <Skeleton className="w-40 h-10" />
          </CardContainer.TopRightContent>
        </CardContainer.Header>
        <CardContainer.Content>
          <div className="flex justify-between py-2">
            <Skeleton className="w-24 h-4" />
            <Skeleton className="w-20 h-4" />
          </div>
          <div className="flex justify-between py-2">
            <Skeleton className="w-40 h-4" />
            <Skeleton className="w-32 h-8 rounded-xl" />
          </div>
        </CardContainer.Content>
      </CardContainer>
    </div>
  );
};
